import { render } from "./ViewLead.vue?vue&type=template&id=9619d89c&lang=pug"
import script from "./ViewLead.vue?vue&type=script&lang=js"
export * from "./ViewLead.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__